export default __webpack_public_path__ + "static/media/art3.c4da9062.jpg";